import React from 'react';
import * as PropTypes from 'prop-types';
import './index.scss';

const LevelsComponent = (props) => {
  const { level } = props;
  const levelsArray = [...Array(level).keys()];
  return (
    <ul className="userProfileLevel">
      {levelsArray.map(elem => <li key={elem} />)}
    </ul>
  );
};

LevelsComponent.propTypes = {
  level: PropTypes.number.isRequired,
};
export default LevelsComponent;



// WEBPACK FOOTER //
// ./src/components/LevelsComponent/index.js